import { ReceitaDto } from "src/app/pagamento/models/receita-dto";

export const RECEITA_DTO: ReceitaDto[] = [
  {
    codigo: 13,
    descricao: "Taxa Fiscalização CVM",
    nomeEditado: "Taxa de fiscalização - CVM",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 14,
    descricao: "TJLP a Classificar - Perfil Zero - Parcelamento",
    nomeEditado: "TJLP - A classificar - Perfil zero - Parcelamentos",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 15,
    descricao: "TJLP IPI - Parcelamento",
    nomeEditado: "TJLP - IPI - Parcelamentos",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 16,
    descricao: "TJLP IRRF - Parcelamento",
    nomeEditado: "TJLP - IRRF - Parcelamentos",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 17,
    descricao: "Multa IRRF-Rendimentos do Trab e de Qualquer Natureza, como os Provenientes de Pensão, Aposentadoria, Prêmios em Concursos e Comissões-Residentes no Exterior-Oper Intra Orçam",
    nomeEditado: "Multa - IRRF - Rend. trab. - Resid. ext. - Oper. intra-orç.",
    tipo: "E",
    dataExtincao: null
  },
  {
    codigo: 18,
    descricao: "PIS - Parcelamento",
    nomeEditado: "PIS - Parcelamentos",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 19,
    descricao: "Transferências Correntes dos Municípios",
    nomeEditado: "Transferências correntes dos municípios",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 20,
    descricao: "Cofins - Parcelamento",
    nomeEditado: "COFINS - Parcelamentos",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 21,
    descricao: "IOF - Operações Crédito - Parcelamento",
    nomeEditado: "IOF - Operações de crédito - Parcelamentos",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 22,
    descricao: "IOF - Ouro - Parcelamento",
    nomeEditado: "IOF - Ouro - Parcelamentos",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 23,
    descricao: "Juros IRRF-Rendimentos do Trabalho e de Qualquer Natureza, como os Provenientes de Pensão, Aposentadoria, Prêmios de Concursos e Comissões-Resid Ext-Oper Intra Orçamentárias",
    nomeEditado: "Juros - IRRF - Rend. trab. - Resid. ext. - Oper. intra-orç.",
    tipo: "E",
    dataExtincao: null
  },
  {
    codigo: 24,
    descricao: "CSLL - Parcelamento",
    nomeEditado: "CSLL - Parcelamentos",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 25,
    descricao: "IPMF - Parcelamento",
    nomeEditado: "IPMF - Parcelamentos",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 26,
    descricao: "IRRF-Rendimentos do Trabalho de Qualquer Natureza, como os Provenientes de Pensão, Aposentadoria, Prêmios em Concursos e Comissões-Residentes no Exterior-Oper. Intra Orçament.",
    nomeEditado: "IRRF - Rendim. trabalho - Resid. exterior - Oper. intra-orç.",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 28,
    descricao: "Simples Federal a Classificar",
    nomeEditado: "Simples Federal a Classificar",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 29,
    descricao: "CPMF - Parcelamento",
    nomeEditado: "CPMF - Parcelamentos",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 30,
    descricao: "Alienação do Domínio Direto - SPU",
    nomeEditado: "Alienação do Domínio Direto - SPU",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 55,
    descricao: "Simples Nacional - MEI",
    nomeEditado: "Simples Nacional - MEI",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 211,
    descricao: "IRPF - Declaração de Ajuste Anual, Declaração de Saída Definitiva do País e Declaração Final de Espólio",
    nomeEditado: "IRPF - Declaração de ajuste anual, saída do país e espólio",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 1410,
    descricao: "DCTF-Web - Pagamento Unificado",
    nomeEditado: "DCTF-Web - Pagamento Unificado",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 1548,
    descricao: "Taxa de Fiscalização de  Produtos Sob Controle  do Ministério do Exército",
    nomeEditado: "Taxa de fiscalização produtos sob controle do Min. Exército",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 1723,
    descricao: "CPSS - Servidor Civil Ativo - Precatório Judicial e Requisição de Pequeno Valor",
    nomeEditado: "CPSS - Servidor Civil Ativo - Precatório/Requisiç Peq Valor",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 2172,
    descricao: "Cofins - Contribuição para Financiamento Seguridade Social",
    nomeEditado: "COFINS - Contribuição para financiamento da segurid. social",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 3607,
    descricao: "Restituições - outras",
    nomeEditado: "Restituições - Outras",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 3885,
    descricao: "PIS - Receita Operacional",
    nomeEditado: "PIS - Receita operacional",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 4444,
    descricao: "Pagamento Unificado",
    nomeEditado: "Pagamento Unificado",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 4570,
    descricao: "Encargos por Recolhimento fora do Prazo",
    nomeEditado: "Encargos por recolhimento fora do prazo",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 4578,
    descricao: "Encargos por Recolhimento fora do Prazo - Simples Nacional",
    nomeEditado: "Encargos por Recolhimento fora do Prazo - Simples Nacional",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 4737,
    descricao: "Lei nº 12.996, de 2014 - PGFN - Demais Débitos - Parcelamento",
    nomeEditado: "Lei nº 12.996, de 2014 - PGFN - Demais Débitos -Parcelamento",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 5300,
    descricao: "Multa Atraso Entrega Declaração ITR",
    nomeEditado: "Multa por atraso na entrega da DITR",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 5856,
    descricao: "Cofins Não-Cumulativa",
    nomeEditado: "COFINS não-cumulativa",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 6092,
    descricao: "Contribuições Previdenciárias - Recolhimento Exclusivo pela Justiça do Trabalho",
    nomeEditado: "Contribuição Previdenciária - Recolhimento Justiça Trabalho",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 7460,
    descricao: "PIS - Depósito Judicial",
    nomeEditado: "PIS - Depósito judicial",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 7498,
    descricao: "Cofins - Depósito Judicial",
    nomeEditado: "COFINS - Depósito judicial",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 8109,
    descricao: "PIS - Faturamento",
    nomeEditado: "PIS - Faturamento",
    tipo: "P",
    dataExtincao: null
  },
  {
    codigo: 8301,
    descricao: "PIS - Folha de Pagamento",
    nomeEditado: "PIS - Folha de pagamento",
    tipo: "P",
    dataExtincao: null
  },
];
